<div class="search-box">
	<input type="text" class="search-input" placeholder="Zoeken" (keydown.enter)="submitSearch()"
		[formControl]="searchValue" />

	<span class="search-btn" (click)="submitSearch()">
		<fa-icon matSuffix [icon]="['fas', 'search']"></fa-icon>
	</span>
</div>